
const Modal = {
  init(){
    const modalClose = document.querySelector('quote .modal-header .close')

    modalClose.addEventListener('click', (e) => {
      e.preventDefault()
      Modal.close()
    })
  },
  open() {
    document.querySelector('quote').style.display = 'flex'
  },
  close() {
    document.querySelector('quote').style.display = 'none'
  }
}
    